/** Placeholder component for leaderboard adunit */
const AdIMUPlaceholder = (): React.ReactElement => {
  return (
    <div
      data-testid="ad-imu-placeholder"
      className="relative flex h-[250px] w-[300px] items-center justify-center border-gray-700 bg-gray-500 text-gray-700"
    >
      <span className="absolute top-1 text-5xs">ADVERTISEMENT</span>
      <span>IMU</span>
    </div>
  );
};

export default AdIMUPlaceholder;
